var map = {
	"./businesses-icon-1.svg": 231,
	"./businesses-icon-2.svg": 232,
	"./businesses-icon-3.svg": 233,
	"./businesses-icon-4.svg": 234,
	"./colleges-icon-1.svg": 235,
	"./colleges-icon-2.svg": 236,
	"./colleges-icon-3.svg": 237,
	"./colleges-icon-4.svg": 238,
	"./companies-icon-1.svg": 239,
	"./companies-icon-2.svg": 240,
	"./companies-icon-3.svg": 241,
	"./companies-icon-4.svg": 242,
	"./enterprises-icon-1.svg": 243,
	"./enterprises-icon-2.svg": 244,
	"./enterprises-icon-3.svg": 245,
	"./enterprises-icon-4.svg": 246,
	"./institutions-icon-1.svg": 247,
	"./institutions-icon-2.svg": 248,
	"./institutions-icon-3.svg": 249,
	"./institutions-icon-4.svg": 250,
	"./students-icon-1.svg": 251,
	"./students-icon-2.svg": 252,
	"./students-icon-3.svg": 253,
	"./students-icon-4.svg": 254,
	"./universities-icon-1.svg": 255,
	"./universities-icon-2.svg": 256,
	"./universities-icon-3.svg": 257,
	"./universities-icon-4.svg": 258
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 230;